// extracted by mini-css-extract-plugin
module.exports = {"recommended":"_1WrkX6a61_8rqDwKJBg2dT"};